import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router'

export function Layout(props) {
  const children = props.children
  const year = new Date().getFullYear()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/')
  }

  return (
    <main className="App">
      <div className={'body'}>
        <div className="avatar" onClick={handleClick}>
          <div className="profile-img">
            <img src="https://avatars.githubusercontent.com/u/13314295?v=4" />
          </div>
          <div className="profile">
            <h1>Daewoong Kim</h1>
            <h2>Web Developer</h2>
          </div>
        </div>
        {children}
      </div>
      <footer className={'footer'}>
        <div className={'footer-inner'}>
          <p>Daewoong Kim | Copyright © {year}</p>
        </div>
      </footer>
    </main>
  )
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}
